import React, { useState, useEffect } from 'react';
import './style.css';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MapIcon from '@mui/icons-material/Map';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import CallIcon from '@mui/icons-material/Call';
import { HeaderCardapio } from '../../../Components/HeaderCardapio';
import CategoriesNavBar from '../../../Components/CategoriesNavBar/CategoriesNavBar';
import { useParams, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { formatDescription } from '../../../Utills/formatText';
import { t } from '../../../Utills/translations';

const { REACT_APP_URL_API } = process.env;
const MAX_DESC_CHARS = 80;

const stripHtml = (html) => html?.replace(/<[^>]*>/g, '') || '';

const truncateText = (text, max) => {
  const plain = stripHtml(text);
  if (plain.length <= max) return plain;
  return plain.substring(0, plain.lastIndexOf(' ', max)) + '...';
};

const colorMap = {
  'azul-escuro': '#3d489b', azul: '#4892DF', verde: '#3BBF9F',
  cinza: '#A6B1B4', 'cinza-solido': '#f2f2f2', vermelho: '#FF5E5E',
  laranja: '#FF9A38', amarelo: '#FFFF00', roxo: '#800080',
  dourado: '#b99c56', 'azul-marinho': '#1C7FBC', 'azul-solido': '#315694',
  marrom: '#673C0D', branco: '#FFFFFF',
};

const Concierge = () => {
  const [concierge, setConcierge] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const { cliente_id } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');

  const userIp = localStorage.getItem('ip_address');
  const session = localStorage.getItem('session');
  const userLanguage = navigator.language || navigator.userLanguage || 'pt-BR';
  const cor2 = localStorage.getItem('cliente_cor1');
  const cor_custom = localStorage.getItem('cliente_cor_custom');

  const resolvedColor = cor2 === 'outra' ? cor2 : colorMap[cor2] || cor2 || '#3d489b';
  const navBarColor = cor_custom && cor_custom !== 'outra' ? cor_custom : '#000000';

  const cookies = new Cookies();
  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-CSRFToken': cookies.get('csrftoken2'),
  });

  const raw = JSON.stringify({
    cliente_id, ip_address: userIp, language: userLanguage, session,
  });

  useEffect(() => {
    window.fetch(
      `${REACT_APP_URL_API}/apiv2/concierge/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}&language=${userLanguage}`,
      { method: 'POST', credentials: 'omit', headers, body: raw },
    )
      .then((r) => r.json())
      .then((json) => setConcierge(json))
      .catch(console.error);
  }, [cliente_id, apartamento, cliente_url, session_control]);

  // Bloquear scroll quando modal aberto
  useEffect(() => {
    document.body.style.overflow = selectedItem ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [selectedItem]);

  if (concierge === null) return null;

  const navCategories = concierge.concierge.map((cat) => ({
    id: cat.id, nome: cat.nome_item,
  }));

  const sanitizeId = (str) =>
    String(str).replace(/\s+/g, '-').replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase();

  return (
    <div style={{ paddingTop: '60px' }}>
      <HeaderCardapio />

      {navCategories.length > 0 && (
        <CategoriesNavBar categories={navCategories} themeColor={navBarColor} offset={-80} />
      )}

      <Box sx={{ maxWidth: '930px', margin: '10px auto 120px auto', left: '1%', right: '1%', bgcolor: 'var(--background-main)' }}>
        {concierge.concierge.map((category) => {
          const sectionId = sanitizeId(String(category.id));
          return (
            <div key={category.id} id={sectionId}>
              <div className="container-clube-voucher">
                <h2 style={{ color: 'var(--secondary)', fontSize: '16px', fontWeight: 400, padding: '12px 16px 8px' }}>
                  {category.nome_item}
                </h2>

                <div className="concierge-cards-grid">
                  {(category.item_concierge || []).map((item) => {
                    const descPlain = stripHtml(item.descricao);
                    const isLong = descPlain.length > MAX_DESC_CHARS;
                    const hasLinks = item.api_mapa || item.instagramLink || item.site || item.telefone;

                    return (
                      <div
                        key={item.id}
                        className="concierge-card"
                        onClick={() => setSelectedItem(item)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && setSelectedItem(item)}
                      >
                        <div className="concierge-card-header">
                          <p className="concierge-card-nome"
                            dangerouslySetInnerHTML={{ __html: formatDescription(item.nome) }}
                          />
                        </div>

                        {item.descricao && (
                          <p className="concierge-card-desc">
                            {isLong ? truncateText(item.descricao, MAX_DESC_CHARS) : descPlain}
                            {isLong && <span className="concierge-card-more"> +</span>}
                          </p>
                        )}

                        {item.horario_funcionamento && (
                          <div className="concierge-card-horario">
                            <AccessTimeIcon sx={{ fontSize: 13 }} />
                            <span>{t('abertoDas')} {item.horario_funcionamento}</span>
                          </div>
                        )}

                        {hasLinks && (
                          <div className="concierge-card-actions" onClick={(e) => e.stopPropagation()}>
                            {item.telefone && (
                              <a href={item.telefone} className="concierge-action-btn concierge-action-call" aria-label="Ligar" title="Ligar">
                                <CallIcon sx={{ fontSize: 18 }} />
                              </a>
                            )}
                            {item.api_mapa && (
                              <a href={item.api_mapa} target="_blank" rel="noopener noreferrer" className="concierge-action-btn concierge-action-map" aria-label="Mapa" title="Ver no mapa">
                                <MapIcon sx={{ fontSize: 18 }} />
                              </a>
                            )}
                            {item.site && (
                              <a href={item.site} target="_blank" rel="noopener noreferrer" className="concierge-action-btn concierge-action-web" aria-label="Site" title="Abrir site">
                                <LanguageIcon sx={{ fontSize: 18 }} />
                              </a>
                            )}
                            {item.instagramLink && (
                              <a href={item.instagramLink} target="_blank" rel="noopener noreferrer" className="concierge-action-btn concierge-action-insta" aria-label="Instagram" title="Instagram">
                                <InstagramIcon sx={{ fontSize: 18 }} />
                              </a>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </Box>

      {/* Modal de detalhes */}
      {selectedItem && (
        <div className="concierge-modal-overlay" onClick={() => setSelectedItem(null)}>
          <div className="concierge-modal" onClick={(e) => e.stopPropagation()}>
            <div className="concierge-modal-handle" />

            <div className="concierge-modal-header">
              <h3 dangerouslySetInnerHTML={{ __html: formatDescription(selectedItem.nome) }} />
              <IconButton onClick={() => setSelectedItem(null)} size="small" aria-label="fechar">
                <CloseIcon />
              </IconButton>
            </div>

            <div className="concierge-modal-body">
              {selectedItem.horario_funcionamento && (
                <div className="concierge-modal-tag concierge-modal-tag-horario">
                  <AccessTimeIcon sx={{ fontSize: 16 }} />
                  {t('abertoDas')} {selectedItem.horario_funcionamento}
                </div>
              )}

              {selectedItem.descricao && (
                <div
                  className="concierge-modal-desc"
                  dangerouslySetInnerHTML={{ __html: formatDescription(selectedItem.descricao) }}
                />
              )}

              {(selectedItem.telefone || selectedItem.api_mapa || selectedItem.site || selectedItem.instagramLink) && (
                <div className="concierge-modal-actions">
                  {selectedItem.telefone && (
                    <a href={selectedItem.telefone} className="concierge-modal-btn concierge-action-call">
                      <CallIcon sx={{ fontSize: 20 }} />
                      <span>Ligar</span>
                    </a>
                  )}
                  {selectedItem.api_mapa && (
                    <a href={selectedItem.api_mapa} target="_blank" rel="noopener noreferrer" className="concierge-modal-btn concierge-action-map">
                      <MapIcon sx={{ fontSize: 20 }} />
                      <span>Mapa</span>
                    </a>
                  )}
                  {selectedItem.site && (
                    <a href={selectedItem.site} target="_blank" rel="noopener noreferrer" className="concierge-modal-btn concierge-action-web">
                      <LanguageIcon sx={{ fontSize: 20 }} />
                      <span>Site</span>
                    </a>
                  )}
                  {selectedItem.instagramLink && (
                    <a href={selectedItem.instagramLink} target="_blank" rel="noopener noreferrer" className="concierge-modal-btn concierge-action-insta">
                      <InstagramIcon sx={{ fontSize: 20 }} />
                      <span>Instagram</span>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Concierge;
